import axios, { AxiosRequestConfig as _AxiosRequestConfig, Method } from 'axios';
import { Toast } from 'antd-mobile';

export interface AxiosRequestConfig extends _AxiosRequestConfig {
    startTime?: Date;
}

export interface HttpRequest {
    get<T>(url: string, data: any, baseUrl?: string): Promise<T>;
    post<T>(url: string, data: any, baseUrl?: string): Promise<T>;
    delete<T>(url: string, data: any, baseUrl?: string): Promise<T>;
    put<T>(url: string, data: any, baseUrl?: string): Promise<T>;
}

enum HTTPERROR {
    LOGIC_ERROR,
    TIMEOUT_ERROR,
    NETWORK_ERROR
}

const TOKEN_ERROR = [401, 402, 403];

const DEFAULT_CONFIG = {
    baseURL: process.env.BASE_URL
};

// @ts-ignore
const http: HttpRequest = {};
const methods: Method[] = ['get', 'post', 'delete', 'put'];

let authTimer: NodeJS.Timer | null = null;

const isSuccess = (res: any) => res.response;
const resFormat = (res: any) => res.response || res.data || {};

methods.forEach((v: Method) => {
    // @ts-ignore
    http[v] = (url: string, data: any, baseUrl?: string) => {
        const axiosConfig: AxiosRequestConfig = {
            method: v,
            url,
            baseURL: baseUrl || DEFAULT_CONFIG.baseURL,
            headers: {
                Authorization: `Bearer `
            }
        };

        const instance = axios.create(DEFAULT_CONFIG);

        instance.interceptors.request.use(
            cfg => {
                cfg.params = { ...cfg.params, ts: Date.now() / 1000 };
                return cfg;
            },
            error => Promise.reject(error)
        );

        instance.interceptors.response.use(
            response => {
                const rData =
                    typeof response.data === 'object' && !isNaN(response.data.length)
                        ? response.data[0]
                        : response.data;
                if (!isSuccess(rData)) {
                    return Promise.reject({
                        msg: rData.error.errorInfo,
                        errCode: rData.error.errCode,
                        type: HTTPERROR[HTTPERROR.LOGIC_ERROR],
                        config: response.config
                    });
                }
                return resFormat(rData);
            },
            error => {
                if (TOKEN_ERROR.includes(error.response.status)) {
                    Toast.hide();
                    Toast.fail('Authentication failure, Please relogin!');
                    // @ts-ignore
                    clearTimeout(authTimer);
                    authTimer = setTimeout(() => {
                        // window.location.replace('/');
                    }, 300);
                    return;
                }
                return Promise.reject({
                    msg: error.response.statusText || error.message || '服务器开小差了～～～',
                    type: /^timeout of/.test(error.message)
                        ? HTTPERROR[HTTPERROR.TIMEOUT_ERROR]
                        : HTTPERROR[HTTPERROR.NETWORK_ERROR],
                    config: error.config
                });
            }
        );

        if (v === 'get') {
            axiosConfig.params = data;
        } else if (v === 'post') {
            axiosConfig.data = data;
        } else if (data instanceof FormData) {
            axiosConfig.data = data;
        }

        axiosConfig.startTime = new Date();

        return instance
            .request(axiosConfig)
            .then(res => res)
            .catch(err => {
                Toast.hide();
                Toast.fail(err.response || err.msg || err.stack || '服务器开小差了～～～');
                return Promise.reject(
                    axiosConfig.url?.includes('autoScript.set') ? { err } : { err, stack: err.msg || err.stack || '' }
                );
            });
    };
});

export default http;
